import { render, staticRenderFns } from "./SingaporeList.vue?vue&type=template&id=711140b5&scoped=true&"
import script from "./SingaporeList.vue?vue&type=script&lang=js&"
export * from "./SingaporeList.vue?vue&type=script&lang=js&"
import style0 from "./SingaporeList.vue?vue&type=style&index=0&id=711140b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711140b5",
  null
  
)

export default component.exports